import { useEffect, useState } from "react";
import "./loading.style.scss";
import clsx from "clsx";
import useObservable from "@core/hooks/use-observable.hook";
import HttpService from "@core/services/http/http.service";

/** Thao tác xong nhanh hơn mốc này thì không hiện lớp che, tránh trang bị nháy */
const OVERLAY_DELAY = 300;
const BAR_DELAY = 150;

/**
 * - Lớp che cả trang: chỉ cho thao tác của người dùng (POST/PATCH/DELETE, bật/tắt máy…) và chỉ hiện khi chạy lâu hơn 300ms.
 * - Thanh mảnh trên đầu trang: khi tải dữ liệu (chuyển tab, lọc, phân trang), không che và không khoá cuộn trang.
 */
function Loading() {
  const [overlay, setOverlay] = useState(false);
  const [bar, setBar] = useState(false);

  const { subscribeUntilDestroy } = useObservable();

  useEffect(() => {
    let overlayTimer: ReturnType<typeof setTimeout> | undefined;
    let barTimer: ReturnType<typeof setTimeout> | undefined;

    subscribeUntilDestroy(HttpService.isRequesting$, (isRequesting) => {
      clearTimeout(overlayTimer);

      if (isRequesting) {
        overlayTimer = setTimeout(() => setOverlay(true), OVERLAY_DELAY);
      } else {
        setOverlay(false);
      }
    });

    subscribeUntilDestroy(HttpService.isLoading$, (isLoading) => {
      clearTimeout(barTimer);

      if (isLoading) {
        barTimer = setTimeout(() => setBar(true), BAR_DELAY);
      } else {
        setBar(false);
      }
    });

    return () => {
      clearTimeout(overlayTimer);
      clearTimeout(barTimer);
    };
  }, []);

  return (
    <>
      <div className={clsx("pcr-loading-bar", { hidden: !bar })} aria-hidden="true">
        <span />
      </div>
      <div
        className={clsx("fixed bottom-0 left-0 right-0 top-0 z-[9999] flex items-center justify-center", {
          hidden: !overlay,
        })}
        style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
      >
        <span className="loader"></span>
      </div>
    </>
  );
}

export default Loading;
